import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M19.7234 24.688 C19.7234 26.7443 18.0564 28.4113 16 28.4113 C13.9436 28.4113 12.2766 26.7444 12.2766 24.688 M18.2297 8.8494 C18.7702 8.291 19.1028 7.5301 19.1028 6.6916 C19.1028 4.978 17.7137 3.5888 16.0001 3.5888 C14.2864 3.5888 12.8972 4.978 12.8972 6.6916 C12.8972 7.5301 13.2298 8.291 13.7704 8.8494 M23.4468 15.0072 C23.4467 13.2955 22.6623 11.6539 21.2657 10.4436 C19.8692 9.2333 17.975 8.5533 16 8.5533 C14.025 8.5533 12.1309 9.2333 10.7344 10.4436 C9.3378 11.6539 8.5532 13.2955 8.5533 15.0072 C8.5533 17.8392 7.8509 19.9103 6.9746 21.3923 C5.9759 23.0815 5.4765 23.9261 5.4962 24.1278 C5.5188 24.3586 5.5603 24.4314 5.7475 24.5683 C5.9111 24.688 6.7331 24.6879 8.3772 24.6879 L23.6228 24.688 C25.2669 24.688 26.089 24.6879 26.2526 24.5683 C26.4397 24.4314 26.4813 24.3586 26.5039 24.1278 C26.5236 23.9261 26.0242 23.0815 25.0254 21.3923 C24.1491 19.9104 23.4467 17.8392 23.4468 15.0072",
				stroke: "white",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 5.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 16.2176,
				cy: 6.5097,
				r: 2.7925,
				style: { fill: "var(--sticker-accent,#FFD366)" }
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 16.1608,
				cy: 24.9511,
				r: 3.258,
				style: { fill: "var(--sticker-accent,#FFD366)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.4468 15.0072 C23.4467 13.2955 22.6623 11.6539 21.2657 10.4436 C19.8692 9.2333 17.975 8.5533 16 8.5533 C14.025 8.5533 12.1309 9.2333 10.7344 10.4436 C9.3378 11.6539 8.5532 13.2955 8.5533 15.0072 C8.5533 17.8392 7.8509 19.9103 6.9746 21.3923 C5.9759 23.0815 5.4765 23.9261 5.4962 24.1278 C5.5188 24.3586 5.5603 24.4314 5.7475 24.5683 C5.9111 24.688 6.7331 24.6879 8.3772 24.6879 L23.6228 24.688 C25.2669 24.688 26.089 24.6879 26.2526 24.5683 C26.4397 24.4314 26.4813 24.3586 26.5039 24.1278 C26.5236 23.9261 26.0242 23.0815 25.0254 21.3923 C24.1491 19.9104 23.4467 17.8392 23.4468 15.0072 Z",
				style: { fill: "var(--sticker-pastel,#FFE29A)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.7234 24.688 C19.7234 26.7443 18.0564 28.4113 16 28.4113 C13.9436 28.4113 12.2766 26.7444 12.2766 24.688 M18.2297 8.8494 C18.7702 8.291 19.1028 7.5301 19.1028 6.6916 C19.1028 4.978 17.7137 3.5888 16.0001 3.5888 C14.2864 3.5888 12.8972 4.978 12.8972 6.6916 C12.8972 7.5301 13.2298 8.291 13.7704 8.8494 M23.4468 15.0072 C23.4467 13.2955 22.6623 11.6539 21.2657 10.4436 C19.8692 9.2333 17.975 8.5533 16 8.5533 C14.025 8.5533 12.1309 9.2333 10.7344 10.4436 C9.3378 11.6539 8.5532 13.2955 8.5533 15.0072 C8.5533 17.8392 7.8509 19.9103 6.9746 21.3923 C5.9759 23.0815 5.4765 23.9261 5.4962 24.1278 C5.5188 24.3586 5.5603 24.4314 5.7475 24.5683 C5.9111 24.688 6.7331 24.6879 8.3772 24.6879 L23.6228 24.688 C25.2669 24.688 26.089 24.6879 26.2526 24.5683 C26.4397 24.4314 26.4813 24.3586 26.5039 24.1278 C26.5236 23.9261 26.0242 23.0815 25.0254 21.3923 C24.1491 19.9104 23.4467 17.8392 23.4468 15.0072",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				style: { stroke: "var(--sticker-dark,#B87C1F)" }
			})
		]
	});
};
export default SvgBell;
